//import { SYSLogin } from "../ovlsyscomponents/syslogin/features/allactions"
import { SVLNewServiceStep1 } from "../features/svl/svlnewservicestep1/allactions"
import { SVLNewServiceStep2 } from "../features/svl/svlnewservicestep2/allactions"
import { SVLNewServiceStep3 } from "../features/svl/svlnewservicestep3/allactions"

export let features = {
  SVLNewServiceStep1,
  SVLNewServiceStep2,
  SVLNewServiceStep3,
  //SYSLogin,
}
